import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import firebaseConfig from './config/firebase'
import { initializeApp } from 'firebase/app'
import { getAnalytics } from "firebase/analytics";
import router from './router'
import store from './vuex/store';
import { createHead } from '@unhead/vue/client'


const app = initializeApp(firebaseConfig);
const head = createHead()
getAnalytics(app);

createApp(App).use(router).use(store).use(head).use(Quasar, quasarUserOptions).mount('#app')
